import PaymentsSubMenus from "./PaymentSubMenus";
import MyTransactions from "./MyTransactions";
import SuperAdminTransList from "./SuperAdminTransList";
import { useSelector } from "react-redux";

const TransactionsList = () => {
    const { userData } = useSelector((state) => state.user);
    return (
        <>
            <PaymentsSubMenus />
            {
                userData.role_slug === "super_admin" ? <SuperAdminTransList /> : <MyTransactions />
            }
        </>
    )
}

export default TransactionsList;